export default {
  dropdown: "dropdown",
  colorDropdown: "colorDropdown",
  list: "list",
  avatarList: "avatarList",
  checkbox: "checkbox",
  text: "text",
  wrappedtext: "wrappedtext",
  multitext: "multitext",
  number: "number",
  integer: "integer",
  date: "date",
  duration: "duration",
  singleReference: "singleReference",
  multipleReference: "multipleReference",
  label: "label",
  identifier: "identifier",
  tag: "tag"
};
